export const Bio = {
  name: "Dharamvir Gohil",
  roles: [
    "Front End Web Developer",
    "Back End Web Developer",
    "Full Stack Web Developer",
    "Programmer",
  ],
  description:
    "To kickstart my career as a software developer, utilizing my strong programming skills and eager to learn from experienced professionals. My goal is to contribute effectively to projects, innovate, and grow as a versatile developer while adding value to the organization",

  github: "https://github.com/DH4R4M",
  resume: "https://drive.google.com/file/d/1fqXceoqg5fdR1RJq2KUO4J54GkMvW3Kx/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/dharamvirgohil/",
  twitter: "https://x.com/Dharamvir_Sinh1",
};

export const skills = [
  {
    title: "Programming Languages",
    skills: [
      {
        name: "C",
        image: "C-logo.png",
      },
      {
        name: "C++",
        image: "CPP-logo.png",
      },
      {
        name: "Java",
        image: "java-logo.svg",
      },
      {
        name: "Python",
        image: "Python-logo.png",
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "html5-logo.png",
      },
      {
        name: "CSS",
        image: "CSS3-logo.png",
      },
      {
        name: "Bootstrap",
        image: "bootstrap-logo.png",
      },
      {
        name: "Tailwind",
        image: "Tailwind.png",
      },
      {
        name: "JavaScript",
        image: "JavaScript-logo.png",
      },
      {
        name: "React Js",
        image: "React.png"
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "nodejs-logo.svg",
      },
      {
        name: "Express Js",
        image: "Express.png"
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "Git.png",
      },
      {
        name: "GitHub",
        image: "Github.png",
      },
      {
        name: "VS Code",
        image: "vscode-logo.png",
      },
      {
        name: "Linux",
        image: "linux.png",
      },
    ],
  },
];



export const education = [
  {
    id: 0,
    img: "rnwlogo.png",
    school: "Red and White Multimedia Education, Rajkot",
    date: "sep-2023 - Present",
    desc: "Currently expanding my skill set by learning back-end development to complement my front-end expertise. Committed to building a strong foundation in full-stack development through hands-on projects and continuous learning.",
    degree:
      "Full-Stack Web Development",
  },
  {
    id: 1,
    img: "Sau.png",
    school: "Saurashtra University, Rajkot",
    date: "2023 - Present",
    desc: "I am currently pursuing a Bachelor of Computer Applications (BCA) degree from Saurashtra University in Rajkot, Gujarat. My academic focus is on acquiring in-depth knowledge of software development, database management, and programming languages. This foundation is equipping me with the skills necessary to thrive in the ever-evolving field of technology and IT solutions.",
    degree: "Bachelor of Computer Applications (BCA)",
  },
];


// Projects

export const projects = [
  {
    id: 9,
    title: "ShopBay",
    description:
      " ShopBay is a modern e-commerce platform built with React and Vite. It offers a sleek, responsive user interface for browsing products, adding items to the cart, and completing purchases. The app utilizes JSON to handle product data and integrate dynamic features such as filtering and searching products. It's designed to provide users with a smooth, fast shopping experience while showcasing best practices in front-end development.",
    image: "shopbay.png",
    tags: ["HTML5", "CSS3", "JavaScript", "ReactJs", "JSON"],
    category: "web app",
    github: "https://github.com/DH4R4M/shopbay/",
    webapp: "https://shopbay-woad.vercel.app/",
  },

  {
    id: 9,
    title: "Myntra Clone",
    description:
      "This project is a clone of the popular e-commerce platform Myntra, built using HTML, CSS, and JavaScript. It simulates real-world shopping experiences, featuring a product catalog, product detail pages, user authentication (login and signup), and a shopping cart. Product data is stored in a JSON file, and users can browse, filter, and add products to their cart. This project showcases dynamic interaction with the UI, providing an efficient, responsive shopping experience.",
    image: "myntra.png",
    tags: ["HTML5", "CSS3", "JavaScript", "JSON", "WebApp"],
    category: "web app",
    github: "https://github.com/DH4R4M/API_Project-1",
    webapp: "https://api-project-1-delta.vercel.app/",
  },

  {
    id: 9,
    title: "React Paint App",
    description:
      "Paint App is a simple drawing application built with React and JavaScript. Users can choose brush sizes, colors, and create digital art in real-time. The app allows users to save their creations and offers an intuitive, smooth drawing experience.",
    image: "paint app.png",
    tags: ["HTML5", "CSS3", "JavaScript", "ReactJs", "Canvas API"],
    category: "web app",
    github: "https://github.com/DH4R4M/paint-app",
    webapp: "https://paint-app-topaz.vercel.app/",
  },
];